// extracted by mini-css-extract-plugin
export var main = "_W2RlsZLA8_KctxrI2R7";
export var root = "fKA8jGwCD2aYtkQyXzzP";
export var spinnerWrapper = "DFRC6hzly2ySRpLlT9Ab";